module.exports = __webpack_public_path__ + "img/huffpost.e38c5f8b.svg";